import { HSPLITTER } from '../common/config';
import { restartStaffcopDialogCtrl } from '../admin/modals';
import { Filter } from '../common/filter';
import { DIM2CLASS, TYPE2CLASS } from '../core/icon-class';
import { Measure } from '../common/measure';

require('./root.component.scss');

/*
 * Main analytics controller
 */
export class RootCtrl {

  constructor(
    $scope,
    $timeout,
    CurrentFilterService,
    CurrentModelService,
    RouterService,
    FiltersService,
    AggregateDataService,
    PermissionService,
    CurrentFilterDataService,
  ) {
    $scope.currentFilter = CurrentFilterService;
    $scope.filterBar = CurrentFilterService.filterBar;
    $scope.currentModel = CurrentModelService;
    $scope.generateReport = RouterService.generateReport.bind(RouterService);
    $scope.locLabel = Filter.locLabel;
    $scope.FiltersService = FiltersService;
    $scope.permission = PermissionService;
    $scope.getMeasure = Measure.getMeasure;
    $scope.getMeasureLabel = Measure.getMeasureLabel;
    $scope.getMeasures = Measure.getMeasures;
    $scope.TYPE2CLASS = TYPE2CLASS;
    $scope.DIM2CLASS = DIM2CLASS;
    $scope.newFilter = () => RouterService.newFilter();
    $scope.getCellFilter = (...args) => CurrentModelService.model.getCellFilter(
      ...args);
    $scope.getCellLabel = (...args) => CurrentModelService.model.getCellLabel(
      ...args);
    $scope.setMeasure = RouterService.setMeasure.bind(RouterService);
    $scope.selectDim = RouterService.selectDim.bind(RouterService);
    $scope.removeDim = RouterService.removeDim.bind(RouterService);
    $scope.drilldown = RouterService.drilldown.bind(RouterService);
    $scope.router = RouterService;

    Object.defineProperty($scope, 'filter', {
      get: () => $scope.currentFilter.filter,
    });
    Object.defineProperty($scope, 'model', {
      get: () => $scope.currentModel.model,
    });
    Object.defineProperty($scope, 'cube', {
      get: () => $scope.currentModel.cube,
    });
    Object.defineProperty($scope, 'filters', {
      get: () => FiltersService.filters,
    });
    Object.defineProperty($scope, 'visibleDimensions', {
      get: () => $scope.currentFilter.visibleDimensions,
    });

    $scope.splitters = [HSPLITTER];

    /* Escape loading */
    $('#image-spinner-cancel').on('click', function () {
      $('#image-spinner').hide();
    });

    window.updateSize = function () {
      $scope.$broadcast('resize');
    };
    window.addEventListener('resize', function () {
      $scope.$broadcast('resize');
    });

    $scope.$on('reload', () => {
      CurrentFilterDataService.reload(true);
    });

    window.addFilter = (name, value, label) => {
      $scope.router.addFilter(name, value, label);
      $timeout(() => {}, 10);
      return false;
    };

    window.drilldownFilter = (dimension, value, label) => {
      $scope.router.drilldownFilter(dimension, value, label);
      $timeout(() => {}, 10);
      return false;
    };

    window.mode = function (mode) {
      $scope.router.mode = mode;
      $scope.$root.$digest();
    };

    window.reload = function () {
      $scope.$root.$broadcast('reload');
    };

    window.setCellFilter = (drill, cell) => {
      let filter = $scope.getCellFilter(drill, cell);
      $scope.router.toggleFilter(filter);
      $scope.currentFilter.rebuildVisibleDimensions();
      $scope.router.filterChanged();
    };

    $('[data-toggle=\'tooltip\']').tooltip();

    window.changeThreshold = (thresholdTag) => {
      let threshold = thresholdTag.value;
      if (!threshold || threshold < 1) {
        return;
      }
      RouterService.threshold = threshold;
      RouterService.update();
      window.reload();
    };

    $scope.router.init();
  }
}




// WEBPACK FOOTER //
// ./src/layout/root.js